import { ProfileCapability } from 'types/ApiServicesTypes';

export const capabilityBalanceChecker = (capability: ProfileCapability) => {
  return capability.balance > 0;
};

export const liveTradingChecker = capabilityBalanceChecker;
export const backTestingChecker = capabilityBalanceChecker;
export const paperTestingChecker = capabilityBalanceChecker;
